import type { SmartSortProduct } from '@iheartjane/dm-sdk';
import { hideStrikethroughPrice } from '@iheartjane/menu';
import { Button, Typography } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';
import type {
  AvailableWeights,
  ProductSearchResultViewModel,
} from '@jane/bloom/viewModels/productSearch';
import type { AlgoliaProduct } from '@jane/search/types';

import { weightLabel } from './weightLabel';

import styles from './selectWeightForm.module.css';

interface WeightButtonsProps {
  formattedWeight?: AvailableWeights;
  product: ProductSearchResultViewModel;
  selectedWeight: string;
  setSelectedWeight: (weight: string) => void;
  smartProductInstance?: SmartSortProduct<AlgoliaProduct>;
  weight: string;
}

export function WeightButtons({
  formattedWeight,
  product,
  selectedWeight,
  setSelectedWeight,
  smartProductInstance,
  weight,
}: WeightButtonsProps) {
  const { pinnedStore } = useStoreSwitcher();
  const showStrikethrough =
    formattedWeight?.fullPriceFormatted !== formattedWeight?.priceFormatted &&
    !hideStrikethroughPrice(pinnedStore?.state || '');

  return (
    <div className={styles['productCardFormWeightsButton']}>
      <Button
        label={
          <div className={styles['productCardFormWeightsButtonLabel']}>
            {formattedWeight?.priceFormatted && (
              <Typography
                variant="body-semibold"
                data-testid="product-price"
                className={clsx({
                  [styles['productCardFormWeightDealsText']]:
                    product.special_id && showStrikethrough,
                })}
                color="inherit"
              >
                {formattedWeight?.priceFormatted}
              </Typography>
            )}
            {product.special_amount &&
              formattedWeight?.fullPriceFormatted &&
              showStrikethrough && (
                <Typography
                  color="grays-mid"
                  variant="body-semibold"
                  strikeThrough
                >
                  {formattedWeight?.fullPriceFormatted}
                </Typography>
              )}
          </div>
        }
        subLabel={weightLabel(weight)}
        size="jumbo"
        variant={
          selectedWeight === formattedWeight?.formattedWeight
            ? 'tertiary-selected'
            : 'tertiary'
        }
        full
        onClick={() => {
          setSelectedWeight(formattedWeight?.formattedWeight || '');
          if (smartProductInstance) {
            smartProductInstance.click();
          }
        }}
      />
    </div>
  );
}
